import { downloadData, importData } from '@dc-trans/data-layer';

import type { ApiImportData, ApiResponse } from '@dc-trans/data-layer';
import type { AxiosError, AxiosProgressEvent } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { mergeApiErrorNotificationMeta, type MutationOptionsWithNotification } from './utils';

export const useUploadData = (
  options?: MutationOptionsWithNotification<
    ApiResponse<ApiImportData>,
    AxiosError<ApiResponse<ApiImportData>>,
    {
      url: string;
      data: FormData;
      progressCallback: (_progressEvent: AxiosProgressEvent) => void;
    }
  >
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal mengunggah data.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<
    ApiResponse<ApiImportData>,
    AxiosError<ApiResponse<ApiImportData>>,
    {
      url: string;
      data: FormData;
      progressCallback: (_progressEvent: AxiosProgressEvent) => void;
    }
  >({
    ...restOptions,
    mutationFn: importData,
    meta: mergedMeta,
  });
};

export const useDownloadData = (
  options?: MutationOptionsWithNotification<
    {
      data: any;
      filename: string;
    },
    AxiosError<{
      data: any;
      filename: string;
    }>,
    {
      url: string;
      params: any;
    }
  >
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal mengunduh data.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<
    {
      data: any;
      filename: string;
    },
    AxiosError<{
      data: any;
      filename: string;
    }>,
    {
      url: string;
      params: any;
    }
  >({
    ...restOptions,
    mutationFn: downloadData,
    meta: mergedMeta,
  });
};
